import { BRANDING } from "@tasty/shared";

/**
 * Bezahl.io-Wortmarke als Text (kein Bild): "Bezahl" (theme-aware via
 * text-foreground -> weiss im Dark-Theme, dunkel im Light-Theme) + ".io" gruen.
 * Grün kommt aus @tasty/shared branding (Source of Truth für alle Apps).
 */
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span className={className}>
      <span className="text-foreground">Bezahl</span>
      <span style={{ color: BRANDING.primaryColor }}>.io</span>
    </span>
  );
}

export default BrandWordmark;
